module.exports = __webpack_public_path__ + "/img/SOT143-F9STmI.svg";